import ModernTemplate from './ModernTemplate';
import ClassicTemplate from './ClassicTemplate';
import CreativeTemplate from './CreativeTemplate';
// 使用src目录下的图片，可以通过import引入，这样图片会被webpack处理并优化
import modernThumbnail from '../assets/modern-thumb.jpg';
import classicThumbnail from '../assets/classic-thumbnail.jpg';
import creativeThumbnail from '../assets/creative-thumbnail.jpg';

export const templates = {
  modern: ModernTemplate,
  classic: ClassicTemplate,
  creative: CreativeTemplate
};

// 预设模板配置
export const templateConfigs = [
  {
    id: 'modern',
    name: 'Modern 现代简约',
    thumbnail: modernThumbnail,
    isPremium: false,
    styles: {
      fontFamily: 'Roboto, sans-serif',
      primaryColor: '#2196f3'
    }
  },
  {
    id: 'classic',
    name: 'Classic 经典商务',
    thumbnail: classicThumbnail,
    isPremium: false,
    styles: {
      fontFamily: 'Times New Roman, serif',
      primaryColor: '#000000'
    }
  },
  {
    id: 'creative',
    name: 'Creative 创意设计',
    thumbnail: creativeThumbnail,
    isPremium: true,
    styles: {
      fontFamily: 'Poppins, sans-serif',
      primaryColor: '#ff4081'
    }
  }
]; 